const trackedDetailViews = new Map<string, number>();
const MAX_TRACKED_DETAIL_VIEWS = 500;

function pruneTrackedDetailViewsIfNeeded(): void {
  while (trackedDetailViews.size > MAX_TRACKED_DETAIL_VIEWS) {
    const oldestKey = trackedDetailViews.keys().next().value;
    if (!oldestKey) {
      return;
    }

    trackedDetailViews.delete(oldestKey);
  }
}

export function shouldTrackDetailViewForMenuInstance(
  menuInstanceId: string | undefined,
  entityType: "comic" | "release",
  entityId: number,
): boolean {
  if (!menuInstanceId) {
    return true;
  }

  const key = `${entityType}:${menuInstanceId}:${entityId}`;
  if (trackedDetailViews.has(key)) {
    return false;
  }

  trackedDetailViews.set(key, Date.now());
  pruneTrackedDetailViewsIfNeeded();
  return true;
}
